import React from 'react';
import FuseShortcuts from '@fuse/core/FuseShortcuts';
import FuseSidePanel from '@fuse/core/FuseSidePanel';

function LeftSideLayout3() {
	return (
		<FuseSidePanel>
			<FuseShortcuts className="px-8 py-16" variant="vertical" />
		</FuseSidePanel>
	);
}

export default React.memo(LeftSideLayout3);
